module.exports = __webpack_public_path__ + "static/media/discover.0726586b.png";